import { combineReducers } from '@shared/redux';
import { updateClusterReducer } from './update-cluster';
import { mutateClustersReducer } from './mutate-clusters';
import { clustersReducer } from './clusters';

export const omnichannelBudgetManagerReducer = combineReducers({
    clusters: clustersReducer,
    updateCluster: updateClusterReducer,
    mutateClusters: mutateClustersReducer,
});
